import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { getTokenUri } from '../../../../services/NFTMarketPlace/Graphquery'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import { IAvawareAllenCard } from '../Cards/AvawareAllenCard'
import { IActivityDetail } from './ActivityDetail'
import BaseActivity from './BaseActivity'


export default function AvawareAllenActivtyDetail({ collection, historyItem, chainId }: IActivityDetail) {
  const { tokenId } = historyItem
  const [tokenUri, setTokenUri] = useState('')
  const [detailTokenItem, setDetailTokenItem] = useState<IAvawareAllenCard | null>(null)

  useEffect(() => {
    if (tokenId !== undefined && tokenId !== null && !tokenUri) {
      getTokenUri(collection.tokenAddress, tokenId).then(res => setTokenUri(res))
    }
    if (tokenUri) {
      let newTokenUri = tokenUri.replace('http:', 'https:').replace('https://localhost:3000', 'https://avaware.network')
      if (collection.tokenAddress.toLowerCase() === '0xc6a02823e3001c3c625d77babf299cd76182b174') {
        newTokenUri = newTokenUri.replace('_7', '_8')
      }
      Api.get(newTokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenUri, collection.tokenAddress, tokenId])

  const tokenName = detailTokenItem ? detailTokenItem.name : collection.name

  return (
    <BaseActivity chainId={chainId} historyItem={historyItem} collection={collection} tokenName={tokenName}>
      {detailTokenItem ? <img src={detailTokenItem.image} alt={detailTokenItem.name} /> : <NFTImageSkeleton />}
    </BaseActivity>
  )
}